import axios from "axios";
import { PartnerCourse } from "../types/course";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const fetchCourses = async (): Promise<PartnerCourse[]> => {
  const response = await api.get("/courses/all");
  return response.data;
};

export const searchCourses = async (
  searchTerms: string[]
): Promise<PartnerCourse[]> => {
  const terms = searchTerms.join(" ");
  const response = await api.get(`/courses/search`, {
    params: {
      terms,
    },
  });
  console.log(`/courses/search?terms=${terms}`);
  return response.data;
};

export const fetchCourseMappings = async (
  university: string
): Promise<PartnerCourse[]> => {
  const response = await api.get(`/courses/mappings?university=${university}`);
  return response.data;
};
